import React from 'react';
import Modal from './Modal';
import { FaRegTrashCan } from "react-icons/fa6";
function DeleteModal({
    deleting,
    deleteAnswer,
    setDeleteAnswer,
    deleteAsset,
    showDelete,
    closeDelete,
    assetType
}) {
    return (
        <Modal
            isOpen={showDelete}
            title={`Delete ${assetType.charAt(0).toUpperCase() + assetType.slice(1)}`}
            onClose={closeDelete}
        >
            <div className="helper-text">
                <div>
                    Are you sure you want to delete this {assetType}?
                </div>
                <div>
                    This action cannot be reversed.
                </div>
            </div>
            <form style={{ marginTop: '1rem' }} onSubmit={deleteAsset}>
                <div className="form-group">
                    <div style={{ fontWeight: 'bold', fontSize: '0.9rem', textAlign: 'center' }}>
                        To confirm deletion, type <em>delete</em> below
                    </div>
                    <input type="text" placeholder="delete" onChange={(e) => {
                        setDeleteAnswer(e.target.value)
                    }} />
                    <button type="submit" className="delete-button" disabled={deleteAnswer !== 'delete' || deleting}>
                        <FaRegTrashCan /> &nbsp;Delete
                    </button>
                </div>
            </form>
        </Modal>
    )
}

export default DeleteModal;